const Pagination = ({
    currentPage,
    totalItems,
    itemsPerPage,
    currentItems,
    onPageChange,
}) => {
    const totalPages = Math.ceil(totalItems / itemsPerPage);

    const startIndex =
        totalItems === 0
            ? 0
            : (currentPage - 1) * itemsPerPage + 1;

    const endIndex = Math.min(
        (currentPage - 1) * itemsPerPage + currentItems.length,
        totalItems
    );

    const getVisiblePages = () => {
        const pages = [];

        // 5 or fewer pages
        if (totalPages <= 5) {
            for (let i = 1; i <= totalPages; i++) {
                pages.push(i);
            }

            return pages;
        }

        // Page 1, 2, 3
        if (currentPage <= 3) {
            pages.push(
                1,
                2,
                3,
                "...",
                totalPages
            );
        }

        // Last 3 pages
        else if (currentPage >= totalPages - 2) {
            pages.push(
                1,
                "...",
                totalPages - 2,
                totalPages - 1,
                totalPages
            );
        }

        // Middle pages
        else {
            pages.push(
                1,
                "...",
                currentPage - 1,
                currentPage,
                currentPage + 1,
                "...",
                totalPages
            );
        }

        return pages;
    };

    return (
        <div
            className="d-flex justify-content-between align-items-center mt-3"
            style={{ borderRadius: 5 }}
        >
            <div>
                Showing {startIndex} to {endIndex} of {totalItems} Entries
            </div>

            <div className="div-button text-center">

                {/* Previous */}
                <button
                    className="borderleft-radius-5"
                    style={{ color: "#4A7729" }}
                    onClick={() => onPageChange(currentPage - 1)}
                    disabled={currentPage === 1}
                >
                    Prev
                </button>

                {/* Page Numbers */}
                {getVisiblePages().map((page, index) =>
                    page === "..." ? (
                        <button
                            key={`dots-${index}`}
                            className="ul-pagination page-item"
                            disabled
                        >
                            ...
                        </button>
                    ) : (
                        <button
                            key={page}
                            className={`ul-pagination page-item ${currentPage === page ? "active" : ""
                                }`}
                            onClick={() => onPageChange(page)}
                            disabled={currentPage === page}
                        >
                            {page}
                        </button>
                    )
                )}

                {/* Next */}
                <button
                    className="borderright-radius-5"
                    style={{ color: "#4A7729" }}
                    onClick={() => onPageChange(currentPage + 1)}
                    disabled={
                        currentPage === totalPages ||
                        totalPages === 0
                    }
                >
                    Next
                </button>

            </div>
        </div>
    );
};

export default Pagination;